import { Accordion } from '@/components/Accordion';
import { useIsCrawler } from '@/hooks';
import { cn } from '@/utils';

import FaqItem from './FaqItem';

function FaqsAccordion({ children, faqList, className }) {
	const isCrawler = useIsCrawler();

	const faqsDefaultValueList = faqList.map((_, index) => {
		return 'faq-' + (index + 1);
	});

	return (
		<div
			className={cn(
				'container flex w-full flex-col items-center lg:max-w-[814px]',
				className
			)}
		>
			{children}
			<div className="inline-flex w-full flex-col items-start justify-start">
				<Accordion
					defaultValue={isCrawler ? faqsDefaultValueList : []}
					type={isCrawler ? 'multiple' : 'single'}
					collapsible
					className="w-full"
					isFaqs
				>
					{faqList.map((faq, index) => {
						return (
							<FaqItem
								value={faqsDefaultValueList[index]}
								question={faq.question}
								answer={faq.answer}
								key={index + faq.question}
							/>
						);
					})}
				</Accordion>
			</div>
		</div>
	);
}

export default FaqsAccordion;
